import firebase from 'firebase/app';
require('firebase/messaging');

let firebaseMessaging;
if (process.env.NODE_ENV === 'production') {
  firebase.initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG));
  try {
    firebaseMessaging = firebase.messaging();
    firebaseMessaging.usePublicVapidKey(process.env.VUE_APP_FCM_VAPID_KEY);
  } catch (e) {
    // unsupported browser
  }
}

export {
  firebaseMessaging
}
